module.exports = __webpack_public_path__ + "static/img/wxlivein.83c2acc.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/wxlivein.png
// module id = KUZ5
// module chunks = 0